export const Endpoints = {
  news: 'news_rss.html'
}

export function url (endpoint: string): string {
  return 'https://beta.bide-et-musique.com/' + endpoint
}

export const URLs = {
  liveStream: 'https://relay2.bide-et-musique.com:9300/bm.mp3'
}
